/* eslint-disable camelcase */
import algoliasearch from 'algoliasearch'

let client = algoliasearch('V88U824HQL', '29795a5eb8b05db6419c1315e303dc2e')

let index_product_name
if (baseUri === "https://triny.pl/" || baseUri === "http://b2b.malowia.pl/") {// eslint-disable-line
  index_product_name = 'prod_products'
} else {
  index_product_name = 'prod_products'
}
export const index = client
export const product_name = index_product_name



// WEBPACK FOOTER //
// ./src/api/algolia/api.js